// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// --- 3rd Party
import { NgxSpinnerModule } from 'ngx-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressBarModule} from 'angular-progress-bar';
import { NgxCaptchaModule } from 'ngx-captcha';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { InViewportModule } from '@thisissoon/angular-inviewport';

// --- HS Code
import * as c from './';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { HightlightWordPipe } from './pipes/hightlight-word.pipe';
import { TokenInterceptorService } from '../core/interceptors/token-interceptor.service';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { EditableOnEnterDirective } from './directives/editable-on-enter.directive';
import { EditInPlaceComponent } from './edit-in-place/edit-in-place.component';


// #endregion

@NgModule({
  declarations: [
    CapitalizePipe,
    HightlightWordPipe,
    TimeAgoPipe,
    c.ShellComponent,
    c.HeroImageComponent,
    c.DemographicsComponentComponent,
    c.EditboxComponent,
    c.LanguagePickerComponent,
    c.ToggleIconComponent,
    c.LogoNavComponent,
    c.CustomAlertComponent,
    c.ProgressBarComponent,
    c.FieldErrorComponent,
    c.ClickStopPropagationDirective,
    c.ClickPreventDefaultDirective,
    c.OnlineStatusComponent,
    c.LanguageSelectControlComponent,
    c.ViewModeDirective,
    c.EditModeDirective,
    EditInPlaceComponent,
    EditableOnEnterDirective,
    c.FocusableDirective
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    ProgressBarModule,
    NgbModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    InViewportModule
  ],
  providers: [   {
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptorService,
    multi: true
  }],
  exports: [
    NgxSpinnerModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CapitalizePipe,
    HightlightWordPipe,
    TimeAgoPipe,
    c.DemographicsComponentComponent,
    c.LanguagePickerComponent,
    c.HeroImageComponent,
    ProgressBarModule,
    NgxCaptchaModule,
    NgbModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    InViewportModule,
    c.EditboxComponent,
    EditInPlaceComponent,
    c.ToggleIconComponent,
    c.LogoNavComponent,
    c.CustomAlertComponent,
    c.ProgressBarComponent,
    c.FieldErrorComponent,
    c.ClickStopPropagationDirective,
    c.ClickPreventDefaultDirective,
    c.LanguageSelectControlComponent,
    c.OnlineStatusComponent,
    c.EditModeDirective,
    c.ViewModeDirective,
    c.FocusableDirective,
    EditableOnEnterDirective
  ]
})
export class SharedModule {}
